import { Select, SelectItem } from '@heroui/react'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { $fetch } from 'utils/fetch'
import { parsePathwayTags } from 'utils/funcs/call-logs/parsePathwayTags'

export default function TagsSelect({ value, pathwayId, ...props }) {
  const { data: pathways } = useQuery({
    queryKey: ['pathways'],
    queryFn: () => $fetch('/v1/pathway'),
    staleTime: 1000 * 60 * 10,
  })

  const pathway = useMemo(() => pathways?.find(p => p.id === pathwayId), [pathways, pathwayId])

  const { data } = useQuery({
    queryKey: ['productionVersion', pathwayId],
    queryFn: () => $fetch(`/v1/pathway/${pathwayId}/version/${pathway?.production_version_number}`),
    enabled: !!pathway,
    staleTime: Infinity,
  })

  const availableTags = useMemo(() => {
    if (!data)
      return []

    // Extract tags from nodes, flatten the array, filter out falsy values
    const allTags = data.nodes.map(node => node.data?.tag).flat().filter(Boolean)

    return parsePathwayTags(allTags)
  }, [data])

  return (
    <Select
      aria-label="Tags"
      isDisabled={!pathwayId}
      placeholder={!pathwayId ? 'First add a Pathway filter' : !availableTags?.length ? 'No tags found' : 'Select tags'}
      selectedKeys={[value]}
      renderValue={(selectedKeys) => {
        return selectedKeys[0].rendered
      }}
      {...props}
    >
      {availableTags?.map(tag => (
        <SelectItem key={JSON.stringify(tag)}>
          <div className="flex flex-row items-center gap-2">
            <div className="size-3 rounded-full" style={{ backgroundColor: tag.color ?? 'gray' }} />
            <span>{tag.name}</span>
          </div>
        </SelectItem>
      ))}
    </Select>
  )
}
